// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-toggle=collapse] .more-alerts-button {\n  display: none;\n}\n[data-toggle=collapse].collapsed .more-alerts-button {\n  display: inline;\n}\n[data-toggle=collapse].collapsed .fewer-alerts-button {\n  display: none;\n}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
